import styled from 'styled-components';

export const MainHeaderWrapper = styled.div`
  position: relative;
  margin-bottom: 35px;
  ${props => props.theme.mediaQueries.tablet_big_down_team_next_widget}{
    margin-bottom: 105px;
  };
`;

export const MatchWidgetWrapper = styled.div`
  text-align: center;
  z-index: 24;
  position: relative;
  max-width: 390px;
  margin: auto;
  top: 35px;
  ${props => props.theme.mediaQueries.tablet_big_down_team_next_widget}{
      top: 30px;
      width: 95%;
    }
  .HeaderShadow {
    box-shadow: rgba(0,0,0,0.5) 0px -15px 12px -4px;
    width: 96%;
    height: 20px;
    z-index: 1;
    margin: -20px auto 0px auto;
  }     
`;

export const NextMatchWrapper = styled.div`
    z-index: 10;
    position: relative;
    display: block;
    text-align: center;
    margin: auto;
    height: 27px;
    background: ${props => props.theme.colors.mainColor};
    clip-path: polygon(2% 0, 98% 0, 100% 100%, 0 100%);
    border-radius: 13px 13px 5px 5px;
    ${props => props.theme.mediaQueries.tablet_big_down_team_next_widget}{
      border-radius: 11px 11px 5px 5px;
    }
`;

export const DataMatchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0px 20px;
  padding-top: 5px;
  font-family: ${props => props.theme.fontSets.narrowRegular};
  ${props => props.theme.mediaQueries.tablet_big_down_team_next_widget}{
    margin: auto;
    padding: 10px 20px;
    border: 1px solid rgb(199,199,199);
    margin-top: 5px;
  };
`;

export const DataMatchWrapperPoint = styled.a`
  display: flex;
  text-decoration: none;
  flex-direction: column;
  justify-content: center;
  ${props => props.theme.mediaQueries.tablet_big_down_team_next_widget}{
    flex-direction: column;
  }
`;

export const HeaderShadow = styled.span`
    width: 406px;
    ${props => props.theme.mediaQueries.tablet_big_down_team_next_widget}{
      width: 95%;
      max-width: 400px;
    }
    height: 30px;
    background-color: #ff000000;
    position: absolute;
    top: ${props => (props.isMobile ? '195px' : '160px')};
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    box-shadow: rgba(0, 0, 0, 0.5) 0px -12px 18px -2px;
`;

export const TeamLink = styled.a`
  text-decoration: none;
  color: ${props => props.theme.colors.black};
  display: flex;
  align-items: center;
`;



// WEBPACK FOOTER //
// ./src/components/TeamNextWidget/styles.js